<!--
 * @Author: QWX
 * @Description:子订单模块
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-28 18:44:09
-->
<template>
  <el-card class="order-choosen">
    <div slot="header" class="">
      <span class="saas-card-header-name" >选择子订单</span>
    </div>
    <div class="">
      <zl-page-table :data="accountSubOrderDTO"  style="width: 100%" stripe class="m-b-8">
        <el-table-column type="index" label="序号" width="50px"></el-table-column>
        <el-table-column label="子订单编号"  prop="subOrderCode"></el-table-column>
        <el-table-column label="对应主订单名称"  prop="orderName">
          <template slot-scope="{row}">
            <el-link type='primary' @click="openMainOrder(row.orderId)">{{row.orderName}}</el-link>
            <span class='super-budge' v-if="row.subOverBudget">超预算</span>
          </template>
        </el-table-column>
        <el-table-column label="主订单种类"  prop="orderType">
          <template slot-scope="{row}">
            {{getValue('orderCategory',row.orderType)}}
          </template>
        </el-table-column>
        <el-table-column label="主订单下单时间"  prop="releaseTime">
          <template slot-scope="{row}">
            {{dayjs(row.releaseTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="子订单验收时间"  prop="checkTime">
          <template slot-scope="{row}">
            {{dayjs(row.checkTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="验收金额(元)"  prop="checkAmount">
          <template slot-scope="{row}">
            {{row.checkAmount | $zlFiltersMoneyFormat}}
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="fromPage !== 'purchaser'" label="退货金额(元)" prop="returnsAmount">
          <template slot-scope="{row}">
            {{row.returnsAmount | $zlFiltersMoneyFormat}}
          </template>
        </el-table-column> -->
        <el-table-column label="最终结算金额(元)"  prop="accountMoney">
          <template slot-scope="{row}">
            {{row.accountMoney | $zlFiltersMoneyFormat}}
          </template>
        </el-table-column>
        <el-table-column label="币种"  prop="currencyCH"></el-table-column>
        <el-table-column label="折合人民币"  prop="accountRmb">
          <div slot="header">
            <el-tooltip effect="dark" content="折合人民币是为了后续统计用，仅做展示用，结算时仍需用原币种进行结算" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
            折合人民币
          </div>
        </el-table-column>
        <el-table-column label="采购单位"  prop="purchaseName"></el-table-column>
        <el-table-column fixed="right" label="操作" >
          <template slot-scope="{row}">
            <el-link type="primary" @click="goDetail(row)">
              查看
            </el-link>
          </template>
        </el-table-column>
      </zl-page-table>
      <div class="order-choosen-bottom">
        <el-form
          label-position="right"
          label-width="60px"
          :disabled="true"
        >
          <el-row >
            <el-col :span="24">
              <el-form-item label="备注:" prop="remark" >
                <el-input type="textarea" :value="baseInfo.remark" :rows="4"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件:" prop="fileId" >
                <zs-upload  :multiple="false" :isDisabled="true" :value="baseInfo.fileId">
                </zs-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="order-choosen-footer">
          <p class="finalCount">
            <span class="label">最终结算金额(元)：</span>
            <template v-for="(item, index) in accountMoney" >
              <i class="divider" :key="index" v-if="index !== 0"></i>
              <span class="rmb" :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
            </template>
          </p>
        </div>
      </div>
    </div>
    <orderDetail ref="orderDetail"/>
    <orderDetailDrawer ref="orderDetailDrawer"/>
  </el-card>
</template>

<script>
import { getValue } from '@/lib/enum'
import zsUpload from '@/components/zsUpload'
import orderDetail from '@/components/reconciliationAndSettlement/orderDetail.vue'
import orderDetailDrawer from '@/components/reconciliationAndSettlement/orderDetailDrawer.vue'
import dayjs from 'dayjs'
import { ZlPageTable } from 'truelore-public' // 组件库
export default {
  components: { zsUpload, ZlPageTable, orderDetail, orderDetailDrawer },
  props: {
    fromPage: {
      type: String,
      default: ''
    },
    baseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      getValue,
      dayjs
      // accountSubOrderDTO: []
    }
  },
  methods: {
    goDetail(row) {
      this.$refs.orderDetail.open(row.id)
    },
    openMainOrder(id) {
      this.$refs.orderDetailDrawer.open(id)
    }
  },
  computed: {
    accountSubOrderDTO() {
      return this.baseInfo.accountSubOrderDTO || []
    },
    accountMoney() {
      // 合并相同币种 再展示
      const arr = []
      const map = new Map()
      JSON.parse(this.baseInfo.accountMoney || '[]').map((p, index) => {
        if (map.has(p.currencyCh)) {
          arr[map.get(p.currencyCh)].money = this.$zl.util.add(arr[map.get(p.currencyCh)].money, p.money)
        } else {
          map.set(p.currencyCh, arr.length)
          arr.push(p)
        }
      })
      return arr
    }
  }

}
</script>
<style lang="scss" scoped>
.order-choosen{
   .super-budge{
      display: inline-block;
      height: 20px;
      padding: 0 5px;
      vertical-align: middle;
      text-align: center;
      line-height: 18px;
      border-radius: 10px;
      border: 1px solid #FF473C;
      font-size: 12px;
      color: #FF473C;
      transform: scale(0.9);
   }
   .order-choosen-bottom{
      margin-top: 32px;
      border-top: 1px dashed rgba(0, 0, 0, 0.11);
      padding-top: 32px;
   }
   .order-choosen-footer{
     height: 48px;
     width: calc(100% + 40px);
     margin-left: -20px;
     margin-bottom: -20px;
     padding:0 24px 0 0;
     line-height: 48px;
     text-align: right;
     box-sizing: border-box;
     box-shadow: 0px -2px 4px 0px rgba(4, 46, 111, 0.05);
      border-radius: 0px 0px 8px 8px;
      p{
        padding: 0;
        margin: 0;
      }
   }
   ::v-deep.zl-page-table .pagination-container{
      text-align: right;
   }
}
</style>
